import axios from 'axios';
import { config } from '../../../config/env';

const url = `${config.jusfyBackend.apiUrl}/v2/me/community-access`;

export async function registerCommunityAccess(): Promise<void> {
  await axios.post<void>(url);
}
